import React, {Component, CSSProperties} from 'react';
import {Navbar} from "react-bootstrap";
import logo from "../logo/bank_logo.svg";

const style: CSSProperties = {
    backgroundColor : "#ea600e"
};

class NavBar extends Component {
    render() {
        return (
            <Navbar style={style} expand="lg">
                <Navbar.Brand>
                    <img src={logo} alt={"CIB Logo"}/>
                </Navbar.Brand>
            </Navbar>
        );
    }
}

export default NavBar;